import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, CTABand, Reveal, Eyebrow } from "@/components/chrome";
import { PROVINCES, CITY_COUNT } from "@/data/provinces";
import { REGIONS } from "@/data/regions";
import { paths } from "@/lib/seo";

export default function LocationsIndex() {
  return (
    <div data-testid="locations-index-page">
      <PageHero
        prefix="locations-index"
        crumbs={[{ name: "Home", path: "/" }, { name: "Locations" }]}
        eyebrow="Service areas"
        title={`Cleaning services in ${CITY_COUNT}+ Canadian cities`}
        lead="Every province. Every territory. One phone number. Tbay Cleaning Services operates insured, background-checked local crews across all of Canada — find your community below."
      />
      <section className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PROVINCES.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.05}>
              <Link to={paths.province(p.slug)} data-testid={`locations-province-${p.slug}`}
                className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-600/40 hover:shadow-[0_16px_40px_-16px_rgba(2,132,199,0.25)]">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{p.code}</span>
                  <ArrowUpRight className="h-4 w-4 text-slate-300 transition-colors group-hover:text-cyan-600" />
                </div>
                <h2 className="mt-4 font-display text-xl font-semibold tracking-tight text-slate-900">{p.name}</h2>
                <p className="mt-2 text-sm text-slate-500">{p.cities.length} {p.cities.length === 1 ? "city" : "cities"} served</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {p.cities.map((c) => c.name).join(" · ")}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="border-t border-slate-200 bg-white" data-testid="locations-regions">
        <div className="mx-auto max-w-7xl px-5 py-14 sm:py-16">
          <Reveal>
            <Eyebrow>Regional hubs</Eyebrow>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Or browse by region
            </h2>
          </Reveal>
          <div className="mt-8 flex flex-wrap gap-3">
            {REGIONS.map((r) => (
              <Link key={r.slug} to={`/regions/${r.slug}`} data-testid={`locations-region-${r.slug}`}
                className="rounded-full border border-slate-200 bg-[#FAFAFC] px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-cyan-600 hover:text-cyan-700">
                {r.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTABand lead="Don't see your community? We add service areas constantly — call and ask." prefix="locations-cta" />
    </div>
  );
}
